import { useState, useEffect, useRef } from "react";
import "./styles.css";
import Papa from "papaparse";
import logo from "./Logo3.png";
import { Link } from "react-router-dom";
//import { SpeedInsights } from "@vercel/speed-insights/react"
//import { Analytics } from "@vercel/analytics/react"

/**
 * Componente principal del juego InazumaDle
 */
function InazumaDle() {
  const [personajes, setPersonajes] = useState([]); 
  const [personajeActual, setPersonajeActual] = useState(null); 
  const [input, setInput] = useState(""); 
  const [sugerencias, setSugerencias] = useState([]); 
  const [historial, setHistorial] = useState([]); 
  const [mensaje, setMensaje] = useState(""); 
  const [intentosPrevios, setIntentosPrevios] = useState(new Set()); 
  const [partidaTerminada, setPartidaTerminada] = useState(false); 
  const [pistaNombreIngles, setPistaNombreIngles] = useState(null);
  const [pistaNombreJapones, setPistaNombreJapones] = useState(null);
  const [pistaNombre, setPistaNombre] = useState(null);
  const [pistaMostrada, setPistaMostrada] = useState(false); // Para controlar si ya se mostró la pista
  const [celdasAnimadas, setCeldasAnimadas] = useState([]); 
  const [animacionesCompletadas, setAnimacionesCompletadas] = useState(new Set()); 
  const [celdasVisibles, setCeldasVisibles] = useState(new Set()); 
  const [showConfetti, setShowConfetti] = useState(false);
  const [trophies, setTrophies] = useState([]);
  const animationRef = useRef();
  const [showVictory, setShowVictory] = useState(false);
  const [countdown, setCountdown] = useState("");
  const [attempts, setAttempts] = useState(() => {
    const savedAttempts = localStorage.getItem('inazumadle_hard_attempts');
    return savedAttempts ? parseInt(savedAttempts) : 0;
  });
  const [winStreak, setWinStreak] = useState(() => {
    const savedStreak = localStorage.getItem('inazumadle_hard_winStreak'); 
    return savedStreak ? parseInt(savedStreak) : 0;
  });
  const [useJapanese, setUseJapanese] = useState(() => {
    // Solo usa japonés si está explícitamente guardado como 'japanese'
    const savedLanguage = localStorage.getItem('inazumadle_languagePreference');
    return savedLanguage === 'japanese'; // false por defecto (inglés)
  });
  const [record, setRecord] = useState(() => {
    const savedRecord = localStorage.getItem('inazumadle_hard_record');
    return savedRecord ? parseInt(savedRecord) : 0;
  });


const physics = {
  gravity: 0.5,
  friction: 0.98,
  terminalVelocity: 15
};

const limpiarCacheAntigua = () => {
  const hoy = new Date();
  const ayer = new Date(hoy);
  ayer.setDate(ayer.getDate() - 1); // Restar 1 día para obtener ayer

  // Formatear fechas en CET (Europe/Madrid)
  const formatoCET = (fecha) => 
    fecha.toLocaleDateString("en-US", { timeZone: "Europe/Madrid" })
      .replace(/\//g, '-');

  const claveHoy = `inazumadle_hard_${formatoCET(hoy)}`;
  const claveAyer = `inazumadle_hard_${formatoCET(ayer)}`;

  // Expresión regular para detectar claves con fecha (inazumadle_MM-DD-YYYY)
  const regexFecha = /^inazumadle_hard_(\d{1,2})-(\d{1,2})-(\d{4})$/;

  Object.keys(localStorage).forEach(key => {
    if (regexFecha.test(key) && key !== claveHoy && key !== claveAyer) {
      localStorage.removeItem(key); // Borra solo registros antiguos (excepto hoy/ayer)
    }
  });
};

  // Referencias para el input y el menú desplegable
  const inputRef = useRef(null);
  const menuRef = useRef(null);

  // Nuevo ref para el contenedor de victoria
  const victoryRef = useRef(null);

  const calculateDayNumber = () => {
  const startDate = new Date('2025-03-1');
  const today = new Date();
  const timeDiff = today - startDate;
  const dayDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  return dayDiff + 1; // Sumamos 1 para que el primer día sea #1
};

const generateEmojiGrid = () => {
  const emojiRows = [];
  const maxAttempts = 7; // Número máximo de intentos a mostrar
  
  for (let i = 0; i < Math.min(attempts, maxAttempts); i++) {
    const attempt = historial[i];
    let emojiRow = "";
    
    if (attempt) {
      attempt.forEach((cell, j) => {
        if (j >= 8) return; // Solo mostramos las primeras 7 columnas
        
        if (cell.color === "green") {
          emojiRow += "🟩";
        } else if (cell.color === "#c0710a") {
          emojiRow += "🟧";
        } else {
          emojiRow += "🟥";
        }
      });
    } else if (i === attempts - 1) {
      // Fila del acierto (todas verdes)
      emojiRow = "🟩".repeat(8);
    } else {
      // Filas no intentadas
      emojiRow = "⬜".repeat(8);
    }
    
    emojiRows.push(emojiRow);
  }
  
  // Añadir indicador si hay más filas no mostradas
  if (attempts > maxAttempts) {
    emojiRows.push(`+ ${attempts - maxAttempts} more rows!`);
  }
  
  return emojiRows.join("\n");
};

const generateTweetMessage = () => {
  const dayNumber = calculateDayNumber();
  const emojiGrid = generateEmojiGrid();
  const playerName = useJapanese && personajeActual['Japanese Name'] ? 
    personajeActual['Japanese Name'] : personajeActual.Name;
  
  return `I just guessed today's character in Inazumadle Hard Mode #${dayNumber} in ${attempts} tries! #InazumaDle 🎉⚽\n\n${emojiGrid}\n\nhttps://www.inazumadle.com/`;
};

  useEffect(() => {
    localStorage.setItem('inazumadle_languagePreference', useJapanese ? 'japanese' : 'english');
  }, [useJapanese]);
  // Modificado para hacer scroll al mensaje de victoria
  useEffect(() => {
    if (showVictory && victoryRef.current) { // Verifica que el elemento exista
      const timer = setTimeout(() => {
        if (victoryRef.current) { // Doble verificación por si cambió de página
          victoryRef.current.scrollIntoView({ 
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
          });
        }
      }, 1000);
      
      return () => clearTimeout(timer); // Limpia el timer al desmontar
    }
  }, [showVictory]);

  const startCountdown = () => {
    const updateCountdown = () => {
      const now = new Date();
      // Ajuste clave: Usamos UTC y luego convertimos a CET
      //Note: hello
      const cetTime = new Date(now.toLocaleString("en-US", { timeZone: "Europe/Madrid" }));
      const midnight = new Date(cetTime);
      midnight.setHours(24, 0, 0, 0); // Medianoche CET (00:00)
      
      const diff = midnight - cetTime;
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      
      setCountdown(`${hours}h ${minutes}m ${seconds}s`);
    };
  
    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);
    return () => clearInterval(timer);
  };

  // Función para generar una clave única basada en la fecha
// Cambiar estas funciones en HardMode.jsx
const getStorageKey = () => {
  const hoy = new Date();
  const fechaCET = hoy.toLocaleString("en-US", { timeZone: "Europe/Madrid" }).split(',')[0];
  return `inazumadle_hard_${fechaCET.replace(/\//g, '-')}`; // Añadir prefijo _hard
};

const loadGameState = (personajesData) => {
  const key = getStorageKey();
  const savedState = localStorage.getItem(key);
  if (!savedState) return null;

  try {
    const parsedState = JSON.parse(savedState);
    
    // Asegurar que el personaje actual tenga todos los campos necesarios
    if (parsedState.personajeActual) {
      const player = personajesData.find(p => 
        p.Name === parsedState.personajeActual.Name || 
        p['Japanese Name'] === parsedState.personajeActual.Name
      );
      
      if (player) {
        parsedState.personajeActual = {
          ...player, // Esto sobrescribe con todos los datos actualizados
          Name: parsedState.personajeActual.Name // Mantenemos el nombre original
        };
      }
    }

    // Procesar historial para asegurar que tenga todos los campos
    const cleanedHistorial = parsedState.historial.map(intento => {
      if (!intento || !Array.isArray(intento)) return [];

      const nameCell = intento.find(item => item.key === "Name");
      const guessedPlayerName = nameCell?.valor;
      const guessedPlayer = personajesData.find(p => 
        p.Name === guessedPlayerName || 
        p['Japanese Name'] === guessedPlayerName
      );

      if (!guessedPlayer) return [];

      const claves = [
        "Name", "Team", "Position", "Element", "Gender", 
        "1st Move", "2nd Move", "First Appear"
      ];

      const newIntento = claves.map(key => {
        const originalCell = intento.find(c => c.key === key);
        const valorGuess = guessedPlayer?.[key] || "";
        const valorReal = parsedState.personajeActual?.[key] || "";

        let color = '#7a1919';
        if (originalCell?.color) {
          color = originalCell.color;
        } else if (key === "Gender") {
          if (valorGuess.toLowerCase() === valorReal.toLowerCase()) color = "green";
        } else if (valorGuess === valorReal) {
          color = "green";
        }

        return {
          key,
          valor: valorGuess,
          color,
          arrow: originalCell?.arrow || null // 👈 AÑADIR ESTO
        };
      });

      return newIntento;
    });

    return {
      ...parsedState,
      historial: cleanedHistorial.filter(h => h.length > 0)
    };
  } catch (error) {
    console.error("Error loading game state:", error);
    return null;
  }
};

// Función para guardar el estado
const saveGameState = (state) => {
  const key = getStorageKey();
  const cleanedHistorial = state.historial.map(intento => {
    return intento.map(cell => ({
      key: cell.key,
      valor: cell.valor || "", // Asegurar que no sea undefined
      color: cell.color || '#7a1919',
      arrow: cell.arrow || null // 👈 AÑADIR ESTO
    }));
  });

  // Limpiar también celdasVisibles para que coincida con 7 columnas
  const cleanedCeldasVisibles = new Set();
  cleanedHistorial.forEach((_, filaIndex) => {
    for (let i = 0; i < 8; i++) {
      cleanedCeldasVisibles.add(`${filaIndex}-${i}`);
    }
  });
  const stateToSave = {
    ...state,
    historial: cleanedHistorial,
    personajeActual: {
      ...state.personajeActual,
      Gender: state.personajeActual.Gender || "" // Asegurar Gender
    }
  };

  localStorage.setItem(key, JSON.stringify(stateToSave));
};

  useEffect(() => {
    if (winStreak > record) {
      const newRecord = winStreak;
      setRecord(newRecord);
      localStorage.setItem('inazumadle_hard_record', newRecord.toString());
    }
  }, [winStreak, record]);
  // Efecto para manejar clicks fuera del input y menú desplegable
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(event.target) &&
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setSugerencias([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Carga inicial de datos desde el archivo CSV
  useEffect(() => {
    limpiarCacheAntigua();
    fetch(`${process.env.PUBLIC_URL || ""}/HardMode.csv?v=9.0`)
    .then(response => response.text())
      .then(csvText => {
        Papa.parse(csvText, {
          header: true,
          complete: (result) => {
          const personajesData = result.data.filter(p => p.Name); // Filtra entradas vacías
          setPersonajes(personajesData);
          
          const savedState = loadGameState(personajesData); // Pasa los personajes cargados
            if (savedState) {
            // Verificar y completar cualquier dato faltante
            const completeState = {
              ...savedState,
              personajeActual: {
                ...savedState.personajeActual,
                Gender: savedState.personajeActual.Gender || 
                       personajesData.find(p => p.Name === savedState.personajeActual.Name)?.Gender || ""
              }
            };           
            setPersonajeActual(completeState.personajeActual);
            setHistorial(completeState.historial);
              setIntentosPrevios(new Set(savedState.intentosPrevios));
              setPartidaTerminada(savedState.partidaTerminada);
              setPistaNombreIngles(savedState.pistaNombreIngles || null);
              setPistaNombreJapones(savedState.pistaNombreJapones || null);
              setPistaMostrada(savedState.pistaMostrada || false);
              setUseJapanese(savedState.useJapanese || false);
              const savedStreak = localStorage.getItem('inazumadle_hard_winStreak');
              setWinStreak(savedStreak ? parseInt(savedStreak) : 0);
              // Forzar visibilidad de TODAS las celdas de los intentos guardados
              const nuevasVisibles = new Set();
              savedState.historial.forEach((_, filaIndex) => {  // ← Usar savedState.historial
              for (let i = 0; i < 8; i++) {
                nuevasVisibles.add(`${filaIndex}-${i}`);
              }
              });
              setCeldasVisibles(nuevasVisibles);
              
              if (savedState.partidaTerminada) {
                setShowVictory(true);
                setAttempts(savedState.historial.length);
                startCountdown();
              }
              saveGameState({
              ...savedState,
              personajeActual: savedState.personajeActual,
              historial: savedState.historial,
              celdasVisibles: nuevasVisibles
            });
            } else {
              seleccionarPersonajeDelDia(personajesData);
            }
          }
        });
      });
  }, []);

    // Modifica el useEffect que maneja el cambio de idioma:
  useEffect(() => {
    if (pistaMostrada) {
      // Solo actualiza la pista mostrada según el idioma, sin regenerar
      setPistaNombre(useJapanese ? pistaNombreJapones : pistaNombreIngles);
    }
  }, [useJapanese, pistaMostrada, pistaNombreIngles, pistaNombreJapones]);

  useEffect(() => {
    if (personajes.length > 0 && personajeActual) {
      const stateToSave = {
        personajeActual,
        historial,
        intentosPrevios: Array.from(intentosPrevios),
        partidaTerminada,
        pistaNombreIngles,
        pistaNombreJapones,
        pistaMostrada,
        celdasVisibles: Array.from(celdasVisibles)
      };
      saveGameState(stateToSave);
    }
  }, [historial, intentosPrevios, partidaTerminada, pistaNombre, celdasVisibles, personajeActual, personajes]);

  useEffect(() => {
    if (showVictory) {
      const cleanup = startCountdown();
      return cleanup; // Esto limpiará el intervalo cuando el componente se desmonte
    }
  }, [showVictory]);

  const seleccionarPersonajeDelDia = (lista) => {
    const personajesValidos = lista.filter(p => p.Name && p.Name.trim() !== '');
    const hoy = new Date();
    const hoyCET = hoy.toLocaleDateString("en-US", { timeZone: "Europe/Madrid" });
    const ayer = new Date(hoy);
    ayer.setDate(ayer.getDate() - 1);
    const ayerCET = ayer.toLocaleDateString("en-US", { timeZone: "Europe/Madrid" });

    // 1. Mejor generación de semilla
    const semillaFecha = hashStringToInt(hoyCET);
    const semillaFija = 23; // Puedes cambiar este valor por otro número primo
    const semillaExtra = hashStringToInt("INAZUMA_ELEVEN_" + hoyCET); // Texto único
    
    // Combinación más robusta de semillas usando XOR y multiplicación
    const semillaCombinada = (semillaFecha ^ semillaFija ^ semillaExtra) * 0x10001;

    // 2. Mejor algoritmo de selección aleatoria
    const randomIndex = robustSeededRandom(semillaCombinada, personajesValidos.length);
    const personajeDelDia = personajesValidos[randomIndex];
    setPersonajeActual(personajeDelDia);
  
    // Modificar las claves para el modo hard
    const lastPlayedDate = localStorage.getItem('inazumadle_hard_lastPlayedDate'); // Cambiado
    
    if (lastPlayedDate !== hoyCET) {
      localStorage.setItem('inazumadle_hard_lastPlayedDate', hoyCET); // Cambiado
      localStorage.setItem('inazumadle_hard_attempts', '0'); // Resetear intentos
      setAttempts(0);
      
      const ayerKey = `inazumadle_hard_${ayerCET.replace(/\//g, '-')}`; // Cambiado
      const partidaAyer = JSON.parse(localStorage.getItem(ayerKey));
  
      if (!partidaAyer?.partidaTerminada) {
        setWinStreak(0);
        localStorage.setItem('inazumadle_hard_winStreak', '0'); // Cambiado
      }
  
      localStorage.removeItem(ayerKey);
    }
  
    return personajeDelDia;
  };

  // Función hash mejorada
function hashStringToInt(str) {
    let hash = 5381; // Número primo inicial
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = ((hash << 5) + hash) + char; // hash * 33 + char
    }
    return hash >>> 0; // Asegura que sea un entero sin signo de 32 bits
}

// Algoritmo aleatorio más robusto (Mulberry32)
function robustSeededRandom(seed, max) {
    let t = seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) % max;
}

  /**
   * Maneja el cambio en el input de búsqueda y muestra sugerencias.
   * @param {Object} e - Evento del input
   */
  const handleInputChange = (e) => {
    if (partidaTerminada) return;
    
    const valor = e.target.value; // Eliminamos trim() aquí para permitir espacios
    setInput(valor);
  
    if (valor.length > 0) {
      const valorLower = valor.toLowerCase();
      
      // 1. Buscar siempre por nombre primero (sin trim para permitir espacios)
      const porNombre = personajes
      .filter(p => {
        const nameToSearch = useJapanese ? p['Japanese Name'] || p.Name : p.Name;
        return nameToSearch.toLowerCase().includes(valorLower) && !intentosPrevios.has(p.Name);
      })
      .map(p => ({
        name: useJapanese ? p['Japanese Name'] || p.Name : p.Name,
        originalName: p.Name, // Guardamos el nombre original para la comparación
        image: `/images/jugadores/${p.Name.toLowerCase().replace(/ /g, "-")}.png`,
        type: 'player'
      }));
  
      // Verificar si el input coincide EXACTAMENTE con algún equipo (con trim solo para la comparación)
      const esEquipoExacto = personajes.some(p => {
        const equipoABuscar = useJapanese ? p['Japanese Team'] || p.Team : p.Team;
        return equipoABuscar && equipoABuscar.toLowerCase().split("/").some(e => e.trim() === valorLower.trim());
      });
  
      if (esEquipoExacto) {
        const nombresIncluidos = new Set(porNombre.map(p => p.name.toLowerCase()));
        
        const porEquipoExacto = personajes
          .filter(p => {
            const equipoABuscar = useJapanese ? p['Japanese Team'] || p.Team : p.Team;
            const enEquipo = equipoABuscar && equipoABuscar.toLowerCase().split("/").some(e => e.trim() === valorLower.trim());
            return enEquipo && !nombresIncluidos.has(p.Name.toLowerCase()) && !intentosPrevios.has(p.Name);
          })
          .map(p => ({
            // Cambio clave aquí: Mostrar nombre japonés si está activo
            name: useJapanese ? p['Japanese Name'] || p.Name : p.Name,
            originalName: p.Name,
            image: `/images/jugadores/${p.Name.toLowerCase().replace(/ /g, "-")}.png`,
            team: useJapanese ? p['Japanese Team'] || p.Team : p.Team,
            type: 'team'
          }));
  
        setSugerencias([
          ...porNombre.slice(0, 20),
          ...porEquipoExacto.slice(0, 60)
        ]);
      } else {
        // Comportamiento normal
        if (porNombre.length === 0) {
          const porEquipo = personajes
            .filter(p => {
              const equipoABuscar = useJapanese ? p['Japanese Team'] || p.Team : p.Team;
              const equipos = equipoABuscar ? equipoABuscar.split("/") : [];
              return equipos.some(equipo => 
                equipo.toLowerCase().includes(valorLower)
              ) && !intentosPrevios.has(p.Name);
            })
            .slice(0, 60)
            .map(p => ({
              // Cambio clave aquí también
              name: useJapanese ? p['Japanese Name'] || p.Name : p.Name,
              originalName: p.Name,
              image: `/images/jugadores/${p.Name.toLowerCase().replace(/ /g, "-")}.png`,
              team: useJapanese ? p['Japanese Team'] || p.Team : p.Team,
              type: 'team'
            }));
          setSugerencias(porEquipo);
        } else {
          setSugerencias(porNombre.slice(0, 20));
        }
      }
    } else {
      setSugerencias([]);
    }
  };

  /**
   * Selecciona una sugerencia del menú desplegable.
   * @param {string} nombre - Nombre del personaje seleccionado
   */
  const seleccionarSugerencia = (nombre, originalName) => {
    setInput(nombre);
    setSugerencias([]);
    handleGuess(originalName || nombre);
  };

  const gameOrder = {
  "Inazuma Eleven 1": 1,
  "Inazuma Eleven 2": 2,
  "Inazuma Eleven 3": 3,
  "Inazuma Eleven GO": 4,
  "Inazuma Eleven GO Chrono Stones": 5
};

  /**
   * Compara las características del intento con el personaje actual.
   * @param {Object} guess - Personaje adivinado
   * @returns {Array} Array de objetos con las características y sus colores correspondientes
   */
  const compararCaracteristicas = (guess) => {
    const keys = [
  "Name", "Team", "Position", "Element", "Gender",
  "1st Move", "2nd Move", "First Appear"
];
  
    return keys.map(key => {
      const valorReal = personajeActual[key] || "";
      const valorGuess = guess[key] || "";
  
      const valoresGuess = valorGuess.split("/");
      const valoresReal = valorReal.split("/");
  
      let color = '#7a1919';
      let arrow = null;
  
      if (valorGuess === valorReal) {
        color = "green";
      } else if (key === "Gender") {
      // Manejo especial para Gender
      if (valorGuess && valorReal && valorGuess.toLowerCase() === valorReal.toLowerCase()) {
        color = "green";
      }
    } else if (key.includes("Move")) {
        const movimientosReales = [
          personajeActual["1st Move"],
          personajeActual["2nd Move"]
        ].map(m => m ? m.split("/") : []).flat();
  
        if (movimientosReales.some(m => valoresGuess.includes(m))) {
          color = "#c0710a";
        }
      } else if (valoresGuess.some(v => valoresReal.includes(v))) {
        color = "#c0710a";
      }else if (key === "First Appear" && valorReal && valorGuess) {
      // Comparar el orden de los juegos
      const realGameOrder = gameOrder[valorReal.trim()] || 0;
      const guessGameOrder = gameOrder[valorGuess.trim()] || 0;
      
      if (guessGameOrder > realGameOrder) {
        arrow = "↓"; // Flecha hacia abajo (el juego del jugador adivinado es posterior)
      } else if (guessGameOrder < realGameOrder) {
        arrow = "↑"; // Flecha hacia arriba (el juego del jugador adivinado es anterior)
      }
    }
      
  
      return { key, valor: valorGuess, color, arrow };
    });
  };

  /**
   * Maneja el intento de adivinar el personaje.
   * @param {string} nombre - Nombre del personaje a adivinar (opcional, usa el input por defecto)
   */
  const handleGuess = (nombre = input) => {
  const clavesMostradas = [
  "Name", "Team", "Position", "Element", "Gender",
  "1st Move", "2nd Move", "First Appear"
];

  
  const acierto = clavesMostradas.map(key => ({
    key,
    valor: personajeActual[key],
    color: "green",
  }));

    
    if (!personajeActual || partidaTerminada) return;

    if (!nombre.trim()) {
      //setMensaje("❌ Please enter a player's name.");
      return;
    }
  
    const guess = personajes.find(p => 
      p.Name.toLowerCase() === nombre.toLowerCase() || 
      (useJapanese && p['Japanese Name'] && p['Japanese Name'].toLowerCase() === nombre.toLowerCase())
    );
    if (!guess) {
      //setMensaje("❌ That player is not on the database.");
      return;
    }
  
    if (intentosPrevios.has(guess.Name)) {
      setMensaje("⚠️ This player was already sent");
      return;
    }
  
    const nuevosIntentos = new Set(intentosPrevios);
    nuevosIntentos.add(guess.Name);
    setIntentosPrevios(nuevosIntentos);
    if (guess.Name.toLowerCase() === personajeActual.Name.toLowerCase()) {
      setAttempts(historial.length + 1);
      setShowVictory(true);
      startCountdown(); 
      const stateToSave = {
        personajeActual,
        historial,
        intentosPrevios: Array.from(intentosPrevios),
        partidaTerminada,
        pistaNombre,
        celdasVisibles: Array.from(celdasVisibles),
        useJapanese // Guardar el estado del idioma
      };
      const newStreak = winStreak + 1;
      setWinStreak(newStreak);
      localStorage.setItem('inazumadle_hard_winStreak', newStreak.toString()); // Cambiado
      saveGameState(stateToSave);
      const colors = [
        '#FFD700', // Oro
        '#FFA500', // Naranja
        '#FF6347', // Tomate
        '#FF4500', // Naranja rojizo
        '#FF8C00'  // Naranja oscuro
      ];
      const PARTICLE_COUNT = 120;
      const newTrophies = Array.from({ length: PARTICLE_COUNT }, (_, i) => ({
        emoji: ['🏆', '🎖️', '🥇', '🏅', '⭐'][Math.floor(Math.random() * 5)],
        size: Math.random() * 50 + 40,
        color: colors[Math.floor(Math.random() * colors.length)],
        id: Math.random().toString(36).substr(2, 9)
      }));
  
      setTrophies(newTrophies);
      setShowConfetti(true);
      setPartidaTerminada(true);
      setTimeout(() => {
        setShowConfetti(false);
      }, 5000);
    
      setHistorial([...historial, acierto]);
    } else {
      setHistorial([...historial, compararCaracteristicas(guess)]);
      const newAttempts = attempts + 1;
      setAttempts(newAttempts);
      localStorage.setItem('inazumadle_hard_attempts', newAttempts.toString());
      
      // Verificar si alcanzó el límite
      if (newAttempts >= 7 && !partidaTerminada) {
        const stateToSave = {
          personajeActual,
          historial,
          intentosPrevios: Array.from(intentosPrevios),
          partidaTerminada,
          pistaNombre,
          celdasVisibles: Array.from(celdasVisibles),
          useJapanese // Guardar el estado del idioma
        };
        const newStreak = 0;
        setWinStreak(newStreak);
        localStorage.setItem('inazumadle_hard_winStreak', newStreak.toString()); // Cambiado
        saveGameState(stateToSave);
        const PARTICLE_COUNT = 60;
        const newTrophies = Array.from({ length: PARTICLE_COUNT }, (_, i) => ({
          emoji: '❌',
          size: Math.random() * 50 + 40,
          color: '#ff0000',
          id: Math.random().toString(36).substr(2, 9)
        }));
        
        setTrophies(newTrophies);
        setShowConfetti(true);
        setPartidaTerminada(true);
        setShowVictory(true);
      }
    }
      animarCeldas(historial.length);
      setInput("");
    setSugerencias([]);
  };

  /**
   * Animación de las celdas de la tabla.
   * @param {number} filaIndex - Índice de la fila a animar
   */
  const animarCeldas = (filaIndex) => {
    const duracionAnimacion = 500;
    const celdasPorFila = 8;
      setCeldasAnimadas(prev => prev.filter(celda => celda.fila !== filaIndex));
  
    for (let i = 0; i < celdasPorFila; i++) {
      setTimeout(() => {
        const idCelda = `${filaIndex}-${i}`;
        if (!celdasVisibles.has(idCelda)) {
          setCeldasAnimadas(prev => [...prev, { fila: filaIndex, celda: i }]);
          setTimeout(() => {
            setCeldasVisibles(prev => new Set(prev).add(idCelda));
          }, duracionAnimacion);
        }
      }, i * duracionAnimacion);
    }
  };

  /**
   * Revela la pista del equipo después de 5 intentos.
   */
  const revelarPistaNombre = () => {
    if (historial.length >= 5 && !pistaMostrada) {
      // Generar pista en inglés
      const nombreIngles = personajeActual.Name;
      const pistaIngles = generarPista(nombreIngles);
      setPistaNombreIngles(pistaIngles);
      
      // Generar pista en japonés (si existe)
      const nombreJapones = personajeActual['Japanese Name'] || personajeActual.Name;
      const pistaJapones = generarPista(nombreJapones);
      setPistaNombreJapones(pistaJapones);
      
      // Mostrar la pista según el idioma actual
      setPistaNombre(useJapanese ? pistaJapones : pistaIngles);
      setPistaMostrada(true);
    }
  };

  const formatImageName = (name) => {
    return name.toLowerCase().replace(/ /g, '_');
  };

  // Función auxiliar para generar la pista
  const generarPista = (nombre) => {
  const letrasReveladas = Math.min(3, nombre.length);
  const letras = nombre.split('');
  
  const indicesDisponibles = letras
    .map((letra, index) => letra === ' ' ? null : index)
    .filter(index => index !== null);
  
  for (let i = indicesDisponibles.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [indicesDisponibles[i], indicesDisponibles[j]] = [indicesDisponibles[j], indicesDisponibles[i]];
  }
  
  const indicesRevelados = indicesDisponibles.slice(0, letrasReveladas);
  
  return letras.map((letra, i) => {
    if (letra === ' ') return ' ';
    return indicesRevelados.includes(i) ? letra : '_';
  }).join('');
};

  return (
    <div className="app-container">
    <div className="p-5 text-center">
    <div className="p-5 text-center">
  {/* Contenedor para el logo y las imágenes laterales */}
  <div className="logo-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
    {/* Imagen izquierda - Modo Endless */}
    <Link to="/endlessmode" id="endless-link">
      <img 
        src="/images/endless.png" 
        alt="Endless Mode" 
        id="endless" 
        className="side-image"
      />
    </Link>
    
    {/* Logo principal */}
    <img src={logo} alt="InazumaDle Logo" className="Logo" />
    
    {/* Imagen derecha - Modo Hard */}
    <Link to="/" id="classic-link">
      <img 
        src="/images/classic.png" 
        alt="Classic Mode" 
        id="classic" 
        className="side-image"
      />
    </Link>
  </div>

  {/* Resto de tu código... */}
</div>

      {/* Input de búsqueda con autocompletado */}
      <div className="contenedor-buscador">
        <input
          ref={inputRef}
          //style={{ width: "340px" }}  // Ancho personalizado
          className="InputBarra"
          value={input}
          onChange={handleInputChange}
          placeholder="Guess the player..."
          disabled={partidaTerminada}
        />

        {sugerencias.length > 0 && (
          <div ref={menuRef} className="menu-desplegable">
            {sugerencias.map((sugerencia, index) => (
              <div
                key={index}
                className="sugerencia"
                onClick={() => seleccionarSugerencia(sugerencia.name, sugerencia.originalName)}

              >
                <img
                  src={sugerencia.image}
                  alt={sugerencia.name}
                  className="imagen-jugador"
                />
                <span className="texto-sugerencia">{sugerencia.name}</span>
              </div>
            ))}
          </div>
        )}
      </div>

          <div className="guess-controls">
      <div className="language-switch">
        <span 
          id="english-flag"
          className={`flag english-flag ${!useJapanese ? 'active' : ''}`} 
          onClick={() => {
            setUseJapanese(false);
            localStorage.setItem('inazumadle_languagePreference', 'english');
          }}
        >
          <img src="/images/earth-globe.png" alt="English" title="Dub Names" />
        </span>
        <span 
          id="japanese-flag"
          className={`flag japanese-flag ${useJapanese ? 'active' : ''}`} 
          onClick={() => {
            setUseJapanese(true);
            localStorage.setItem('inazumadle_languagePreference', 'japanese');
          }}
        >
          <img src="/images/jp-flag.png" alt="Japanese" title="Japanese Names" />
        </span>
      </div>
      
      <button
        className="play-again-button"
        onClick={() => handleGuess()}
        disabled={partidaTerminada}
      >
        Guess
      </button>
      </div>

      {/* Pista del equipo */}
      <div className="mt-4 contenedor-pista">
            <button
        id="pista-button"
        className={`p-2 rounded ${historial.length >= 5 && !pistaMostrada && !partidaTerminada ? "bg-green-500 text-white" : "bg-gray-400 cursor-not-allowed"}`}
        onClick={revelarPistaNombre}
        disabled={historial.length < 5 || pistaMostrada || partidaTerminada}
      >
        {historial.length < 5 ? `Player's random name letters (You need ${5 - historial.length} guesses)` : 
        pistaMostrada ? "Player's name letters revealed" : "Player's random name letters"}
      </button>
        {pistaNombre && (
          <p className="mt-2 text-lg font-bold pista-texto">
          {useJapanese ? 'Name: ' : 'Name: '}
          {pistaNombre}
        </p>
        )}
        <p className="Note">Tip: Search by team name to see all its players.</p>

        <div className="stats-container-wrapper">
        <div className="beststreak-container">
            <div className="thunder-background"></div>
            <span className="streak-number">{record}</span>
            <span className="beststreak-tooltip">Your current Record</span>
          </div>

        <div className="stats-container">
          {/* Contenedor de intentos */}
          <div className="attempts-container">
            Tries: <span className="attempts-number">{attempts}</span>/7
          </div>
          
          {/* Contenedor de streak */}
          <div className="streak-container">
            <div className="fire-background"></div>
            <span className="streak-number">{winStreak}</span>
            <span className="streak-tooltip">Your current Win Streak</span>
          </div>
        </div>
      </div>     
</div>

      {/* Mensajes de feedback */}
      {mensaje && <p className="text-lg mt-4">{mensaje}</p>}

      {/* Tabla de intentos */}
      <h2 className="text-xl mt-6"></h2>
      <div className="mt-3 overflow-x-auto">
        <table className="w-full border-collapse border border-gray-400">
          <thead>
          <tr className="bg-gray-200">
              {["Player", "Team", "Position", "Element", "Gender", "1st Move", "2nd Move", "First Appear"].map((header, i) => (
              <th key={i} className="border border-gray-400 p-2">{header}</th>
            ))}
            </tr>
          </thead>
          <tbody>
  {historial.slice().reverse().map((intento, idx) => (
    <tr key={idx} className="text-center">
      {intento.map((caracteristica, i) => (
        <td
          key={i}
          className={`p-2 text-white ${
            !celdasVisibles.has(`${historial.length - 1 - idx}-${i}`) && 
            celdasAnimadas.some(celda => celda.fila === (historial.length - 1 - idx) && celda.celda === i)
              ? "flip-animation"
              : ""
          }`}
          style={{
            backgroundColor: caracteristica.color,
            opacity: celdasVisibles.has(`${historial.length - 1 - idx}-${i}`) ? 1 : 0,
            visibility: celdasVisibles.has(`${historial.length - 1 - idx}-${i}`) ? 'visible' : 'hidden',
            transform: celdasVisibles.has(`${historial.length - 1 - idx}-${i}`) ? 'scale(1)' : 'scale(0.8)'
          }}
        >
          {caracteristica.key === "Name" ? (
            <img
              src={`/images/jugadores/${personajes.find(p => p.Name === caracteristica.valor)?.Name.toLowerCase().replace(/ /g, "-")}.png`}
              alt={useJapanese 
                ? personajes.find(p => p.Name === caracteristica.valor)?.['Japanese Name'] || caracteristica.valor
                : caracteristica.valor
              }
              className="ImagenIntento"
            />
          ) : caracteristica.key === "Team" ? (
            <div className="team-cell">
              {(
                personajes.find(p => p.Name === historial[historial.length - 1 - idx][0].valor)?.['Team']
                  || caracteristica.valor
              ).split(/(?<!\s)\/(?!\s)/).map((equipo, index) => {
                const personaje = personajes.find(p => p.Name === historial[historial.length - 1 - idx][0].valor);
                const firstAppear = personaje?.["First Appear"];

                const esRaimon = equipo.trim() === "Raimon";
                const esRaimonClasico = firstAppear === "Inazuma Eleven 1" 
                  || firstAppear === "Inazuma Eleven 2"
                  || firstAppear === "Inazuma Eleven 3";

                const nombreEquipo = esRaimon
                  ? esRaimonClasico ? "raimon" : "raimon2"
                  : equipo.trim().toLowerCase().replace(/ /g, "-");

                const tooltip = useJapanese
                  ? personaje?.['Japanese Team']?.split(/(?<!\s)\/(?!\s)/)[index]?.trim() || equipo.trim()
                  : equipo.trim();

                return (
                  <div className="equipo-tooltip-container" key={index}>
                    <img
                      src={`/images/equipos/${nombreEquipo}.webp?v=1`}
                      alt={equipo.trim()}
                      className="equipo-imagen"
                    />
                    <div className="equipo-tooltip">{tooltip}</div>
                  </div>
                );
              })}
            </div>
          ) : caracteristica.key === "Element" ? (
            <div className="elements-container">
              {caracteristica.valor.split('/').map((element, index) => (
                <div key={index} className="element-cell">
                  <img 
                    src={`/${element.trim().toLowerCase()}.png`} 
                    alt={element.trim()}
                    className="element-image"
                  />
                </div>
              ))}
            </div>
          ) : caracteristica.key === "Gender" ? (
            <div className="gender-container">
              <img 
                src={`/${caracteristica.valor.toLowerCase()}.webp`} 
                alt={caracteristica.valor}
                className="gender-image"
              />
            </div>  
          ) : caracteristica.key === "Position" ? (
            <div className="positions-container">
              {caracteristica.valor.split('/').map((position, index) => (
                <div key={index} className="position-cell">
                  <img 
                    src={`/${position.trim().toLowerCase()}.png`} 
                    alt={position.trim()}
                    className="position-image"
                  />
                </div>
              ))}
            </div>
          ) : caracteristica.key === "First Appear" ? (
            <div className="appear-container" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <img 
                src={`/${formatImageName(caracteristica.valor)}.png`}
                alt={`${caracteristica.valor}`}
                className="appear-image"
              />
              {caracteristica.arrow && (
                <span style={{ 
                  color: 'white', 
                  fontSize: "200%",
                  marginLeft: '5px',
                  lineHeight: '1',
                  textShadow: `
                  0 0 4px black,
                  0 0 4px black,
                  0 0 4px black,
                  0 0 4px black
`,
                fontWeight: 'bold'}}>
                  {caracteristica.arrow}
                </span>
              )}
            </div>
          ) : (
            caracteristica.valor
          )}
        </td>
      ))}
    </tr>
  ))}
</tbody>
        </table>
      </div>
      {showVictory && (
  <div ref={victoryRef} className="victory-message">
        <div className="victory-title-container">
      {partidaTerminada && historial.length > 0 && historial[historial.length-1][0].color === "green" ? (
        <>
          <img src="/images/win-left.png" alt="Celebration" className="victory-side-image" />
          <h2 className="game-over-text">YOU WIN!</h2>
          <img src="/images/win-right.png" alt="Celebration" className="victory-side-image" />
        </>
      ) : (
        <>
          <img src="/images/lose-left.png" alt="Game Over" className="victory-side-image" />
          <h2 className="game-over-text">GAME OVER!</h2>
          <img src="/images/lose-right.png" alt="Game Over" className="victory-side-image" />
        </>
      )}
    </div>

    
    <div className="player-info">
      <img 
        src={`/images/jugadores/${personajeActual.Name.toLowerCase().replace(/ /g, "-")}.png`} 
        alt={personajeActual.Name}
        className="victory-player-image"
      />
      <h3>{useJapanese && personajeActual['Japanese Name'] ? personajeActual['Japanese Name'] : personajeActual.Name}</h3>
      <p>Team: {useJapanese && personajeActual['Japanese Team'] ? personajeActual['Japanese Team'] : personajeActual.Team}</p>
    </div>
    
    <div className="victory-stats">
      {historial.length > 0 && historial[historial.length-1][0].color === "green" && (
        <p>You guessed it in: <strong>{attempts}/7 tries</strong></p>
      )}
      <p>Next character in: <strong>{countdown}</strong></p>
    </div>
    
    {historial.length > 0 && historial[historial.length-1][0].color === "green" && (
      <div className="victory-actions">
        <a 
          href={`https://x.com/intent/tweet?text=${encodeURIComponent(generateTweetMessage())}`} 
          target="_blank" 
          rel="noopener noreferrer"
          className="tweet-button"
        >
          Share on X
        </a>
      </div>
    )}
  </div>
)}
</div>
            <footer className="footer">
      <div className="footer-content">
        <p>InazumaDle.com — 2025</p>
        <p>Level-5 does not endorse or sponsor this project.</p>
        
        {/* Primera fila: Enlaces */}
        <div className="footer-links">
      <Link to="/privacy" className="footer-link">Privacy Policy</Link>
      <span>•</span>
      <Link to="/about" className="footer-link">About Me</Link>
      <span>•</span>
      <Link to="/thanks" className="footer-link">Special Thanks</Link>
    </div>

        {/* Segunda fila: Iconos Ko-Fi y Twitter */}
        <div className="footer-kofi">
          <a href="https://ko-fi.com/inazumadle" target="_blank" rel="noopener noreferrer">
            <img src="/images/ko-fi-icon.png" alt="Support me on Ko-fi" className="kofi-icon"/>
          </a>
          <a href="https://x.com/Inazumadle" target="_blank" rel="noopener noreferrer">
            <img src="/images/x.png" alt="Follow me on Twitter" className="twitter-icon" />
          </a>
        </div>
      </div>
    </footer>
      {showConfetti && <TrophyParticles trophies={trophies} physics={physics} />}
    </div>
  );
  
}

const GravityTrophy = ({ emoji, size, color, onRemove, physics }) => {
  const [position, setPosition] = useState({
    x: Math.random() > 0.5 ? -100 : window.innerWidth + 100,
    y: Math.random() * window.innerHeight * 0.3
  });
  const isMobile = window.innerWidth < 768;

  const [velocity, setVelocity] = useState({
    x: (Math.random() > 0.5 ? 1 : -1) * (Math.random() * (isMobile ? 8 : 15) + (isMobile ? 6 : 10)),
    y: Math.random() * (isMobile ? -15 : -20) - (isMobile ? 7 : 10)
  });
  const ref = useRef();

  useEffect(() => {
    let animationId;
    let alive = true;

    const updatePosition = () => {
      if (!alive) return;

      setVelocity(prev => {
        let newY = prev.y + physics.gravity;
        if (newY > physics.terminalVelocity) newY = physics.terminalVelocity;
        return {
          x: prev.x * physics.friction,
          y: newY
        };
      });

      setPosition(prev => {
        const newPos = {
          x: prev.x + velocity.x,
          y: prev.y + velocity.y
        };

        if (newPos.y > window.innerHeight + 100 || 
            newPos.x < -200 || 
            newPos.x > window.innerWidth + 200) {
          setTimeout(() => onRemove(), 0);
          return prev;
        }

        return newPos;
      });

      animationId = requestAnimationFrame(updatePosition);
    };

    animationId = requestAnimationFrame(updatePosition);

    return () => {
      alive = false;
      cancelAnimationFrame(animationId);
    };
  }, [velocity.x, velocity.y, onRemove]);

  return (
    <div
      ref={ref}
      className="gravity-trophy"
      style={{
        position: 'fixed',
        left: `${position.x}px`,
        top: `${position.y}px`,
        fontSize: `${size}px`,
        color: color,
        transform: `rotate(${position.x * 0.5}deg)`,
        transition: 'transform 0.1s ease-out',
        zIndex: 1000,
        pointerEvents: 'none',
        userSelect: 'none',
        textShadow: `0 0 10px rgba(255, 255, 255, 0.8), 0 0 20px ${color}`,
        filter: 'saturate(2.5) brightness(1.2)'
      }}
    >
      {emoji}
    </div>
  );
};

const TrophyParticles = ({ trophies, physics }) => {
  const [activeTrophies, setActiveTrophies] = useState([]);

  useEffect(() => {
    if (trophies.length > 0) {
      setActiveTrophies(prev => [
        ...prev,
        ...trophies.map(t => ({
          ...t,
          id: Math.random().toString(36).substr(2, 9)
        }))
      ]);
    }
  }, [trophies]);

  const removeTrophy = (id) => {
    setActiveTrophies(prev => prev.filter(t => t.id !== id));
  };

  return (
    <>
      {activeTrophies.map(trophy => (
        <GravityTrophy
          key={trophy.id}
          emoji={trophy.emoji}
          size={trophy.size}
          color={trophy.color}
          onRemove={() => removeTrophy(trophy.id)}
          physics={physics} 
        />
      ))}
    </>
  );

};



export default InazumaDle;